import * as React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../modal/Modal';
import Button from '../../../components/form/button/Button';
import { spawnGlobalNotification } from '../../../core/state/global-notifications/asyncActions';
import { GlobalNotificationTypes } from '../../../core/enums/GlobalNotificationTypes';
import { isReadAllRole } from '../../../core/state/user/selectors';

interface Props {
  showIf: boolean;
  onSaveExit?: () => void;
  onDiscardExit?: () => void;
}

const UnsavedChangesModal: React.FC<Props> = ({ showIf = false, onSaveExit, onDiscardExit }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUserReader = useSelector(isReadAllRole);

  const title = <h3 className="modal-title">{t('modal.saveChanges')}</h3>;

  const buttons = (onConfirm: () => void, closeModal: () => void) => (
    <div className="create-booking-modal__buttons">
      <Button buttonTypes={['transparent']} onClick={closeModal}>
        {t('common.cancel')}
      </Button>
      <Button
        buttonTypes={['blue-outline']}
        onClick={() => {
          if (onDiscardExit) {
            onDiscardExit();
          }
          dispatch(
            spawnGlobalNotification({
              type: GlobalNotificationTypes.Info,
              title: t('common.changesDiscarded'),
              message: t('common.changesDiscarded')
            })
          );
          onConfirm();
        }}
      >
        {t('common.discardExit')}
      </Button>
      {!isUserReader && (
        <Button
          buttonTypes={['blue']}
          onClick={() => {
            if (onSaveExit) {
              onSaveExit();
            }
            onConfirm();
          }}
        >
          {t('common.saveExit')}
        </Button>
      )}
    </div>
  );
  return (
    <NavigationPrompt when={showIf}>
      {({ onConfirm, onCancel }) => (
        <Modal isOpen={showIf} closeModal={onCancel} title={title} toolbar={buttons(onConfirm, onCancel)}>
          <div className="modal__text">{t('modal.youHaveMadeChanges')}</div>
        </Modal>
      )}
    </NavigationPrompt>
  );
};

export default UnsavedChangesModal;
